import Actions               from 'Redux/Actions';
import { AppUserRepository, TAppUserOrganisation } from 'Domain/Repositories';
import { ofType }            from 'redux-observable';
import { from }              from 'rxjs';
import { mergeMap }          from 'rxjs/operators';
import { TEpic }             from 'Redux/Config';

export const assignAppUserOrganisationEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.assignAppUserOrganisationRequest.type),
    mergeMap(action => from(
      AppUserRepository.assignOrganisation(action.payload)
        .then(({ organisations }: { organisations: TAppUserOrganisation[] }) => Actions.assignAppUserOrganisationSuccess({ organisations }))
        .catch((error: Error) => Actions.assignAppUserOrganisationFailure({ error })),
    )),
  );
};
